const slotItems = [
  'prize_2nd',

  'prize_3rd_1',
  'prize_3rd_2',

  'prize_4th_1',
  'prize_4th_2',
  'prize_4th_3',
  'prize_4th_4',
  'prize_4th_5',
  'prize_4th_6',

  'prize_5th_1',
  'prize_5th_2',
  'prize_5th_3',
  'prize_5th_4',

  'prize_6th_1',
  'prize_6th_2',
  'prize_6th_3',
  'prize_6th_4',
  'prize_6th_5',
  'prize_6th_6',

  'prize_7th_1',
  'prize_7th_2',
  'prize_7th_3',

  'prize_2digits_1',
  'prize_2digits_2',
  'prize_2digits_3',
  'prize_2digits_4',

  'prize_1st'
]

export { slotItems }
